<template>
  <div v-if="post">
    <!--
  <div class="block">
    <router-link :to="isAdminPath ? `/admin/posts/${serviceId}` : `/posts/${serviceId}`">
      <i class="fas fa-chevron-left"></i>
      <span>{{ $t('common.posts') }}</span>
    </router-link>
  </div>
  -->
    <div
      class="block"
      v-if="isExecuteTarget === true && isLoading === false"
    >
      <div>
        <label class="mr-4">{{ $t('term.timeElapsed') }}</label>
        <span class="is-size-4">{{ elapsedTime | numFormat }}</span>
        <span>{{ $t('common.seconds') }}</span>
      </div>
      <div>
        <label class="mr-4">{{
          $t('term.timeElapsedOf', { target: $t('term.thisQuestion') })
        }}</label>
        <span class="is-size-1">{{ elapsedTimeCurrent | numFormat }}</span>
        <span>{{ $t('common.seconds') }}</span>
      </div>
    </div>

    <post-content
      :post="post"
      :is-disp-title="false"
    ></post-content>

    <div
      v-if="isExecuteTarget === true"
      class="block mt-6"
    >
      <h3 class="title is-5">{{ $t('term.answer') }}</h3>
      <div
        v-if="post.answerType === 'text'"
        class="block"
      >
        <div class="block">
          <b-radio
            v-model="textInputType"
            native-value="text"
            >{{ $t('form.textInput') }}</b-radio
          >
          <b-radio
            v-model="textInputType"
            native-value="handwrite"
            >{{ $t('form.handwriteInput') }}</b-radio
          >
          <b-radio
            v-model="textInputType"
            native-value="file"
            >{{ $t('form.SelectFile') }}</b-radio
          >
        </div>

        <div v-if="textInputType === 'handwrite'">
          <handwrite-input
            v-model="answerImageData"
            :canvas-height-default="300"
          ></handwrite-input>
        </div>
        <div v-else-if="textInputType === 'file'">
          <FileInput
            v-model="files"
            :uploader-options="uploaderOptions"
            :is-draggable="true"
          />
          <ul
            v-if="thumbnails.length > 0"
            class="columns is-multiline is-tablet mt-6"
          >
            <li
              v-for="(thumbnail, index) in thumbnails"
              :key="index"
              class="column is-one-quarter relative"
            >
              <button
                class="delete absolute top-4 right-4"
                @click="deleteFile(index)"
              ></button>
              <img
                :src="thumbnail"
                alt="Thumbnail"
              />
            </li>
          </ul>
        </div>
        <div v-else>
          <b-input
            type="textarea"
            v-model="answerText"
            name="answerText"
            @blur="validateAnswerText()"
          ></b-input>
        </div>
      </div>
      <ul
        v-else-if="post.answerType === 'select'"
        class="block"
      >
        <li
          v-for="(item, index) in post.answersHtml"
          :key="index"
          class="mt-2 columns is-mobile is-1"
        >
          <div class="column is-0 has-text-weight-semibold">
            <span class="has-text-weight-semibold">{{ answerLabels[index] }}</span>
          </div>
          <div class="column is-1 has-text-weight-semibold">
            <b-radio
              v-model="answerNo"
              name="answerNo"
              :native-value="index"
            ></b-radio>
          </div>
          <html-content
            class="column"
            :body="item"
          ></html-content>
        </li>
      </ul>
      <div class="mt-5">
        <button
          class="button is-info"
          :disabled="isEnabledSendAnswer === false"
          @click="sendAnswer"
        >
          {{ $t('common.send') }}
        </button>
      </div>
    </div>

    <div
      v-else-if="
        isLoading === false &&
        isExecuteTarget != null &&
        isExecuteTarget === false &&
        (post.answerExplanation || post.answerExpImages.length > 0)
      "
      class="block mt-6"
    >
      <h3 class="title is-4">{{ $t('term.explanation') }}</h3>
      <html-content
        v-if="post.answerExplanation"
        class="column"
        :body="post.answerExplanationHtml"
      ></html-content>
      <EbImages :images="post.answerExpImages" />
    </div>

    <UserEditMasterStatus
      v-if="isExecuteTarget === false && isUserAuth"
      :post-service-id="serviceId"
      :post-id="post.postId"
    />

    <div
      v-if="isExecuteTarget === false && isUserAuth"
      class="mt-6"
    >
      <h3 class="title is-4">{{ $t('term.answers') }}</h3>
      <ul v-if="userAnswers">
        <li
          v-for="answer in userAnswers"
          class="mt-4 card px-2 py-5"
        >
          <p>
            <time
              itemprop="datepublished"
              :datetime="answer.finishedAt | dateFormat('')"
              >{{ answer.finishedAt | dateFormat }}</time
            >
          </p>
          <router-link
            :to="`/user/answers/${answer.userAnswerId}`"
            class="mt-4"
          >
            {{ $t('common.ShowDetail') }}
          </router-link>
        </li>
      </ul>
      <p v-else>{{ $t("msg['Data is empty']") }}</p>
    </div>

    <!--
  <div class="mt-5">
    <time
      itemprop="datepublished"
      :datetime="post.publishAt | dateFormat('')"
    >{{ post.publishAt | dateFormat }}</time>
  </div>
  -->

    <nav
      v-if="isExecuteTarget === false && post.category"
      class="breadcrumb"
      aria-label="breadcrumbs"
    >
      <ul>
        <li>
          <router-link :to="`/posts/${serviceId}/`">{{ $t('common.posts') }}</router-link>
        </li>
        <li v-for="parent in post.category.parents">
          <router-link :to="`/posts/${serviceId}/categories/${parent.slug}`">{{
            parent.label
          }}</router-link>
        </li>
        <li>
          <router-link :to="`/posts/${serviceId}/categories/${post.category.slug}`">{{
            post.category.label
          }}</router-link>
        </li>
      </ul>
    </nav>

    <ul v-if="'tags' in post && post.tags">
      <li
        v-for="tag in post.tags"
        class="is-inline-block mr-2"
      >
        <router-link
          :to="`/posts/${serviceId}/tags/${tag.label}`"
          class="tag"
          >{{ tag.label }}</router-link
        >
      </li>
    </ul>
  </div>
</template>
<script>
import utilDate from '@/util/date'
import config from '@/config/config'
import { Post, User } from '@/api'
import PostContent from '@/components/organisms/PostContent'
import HtmlContent from '@/components/atoms/HtmlContent'
import HandwriteInput from '@/components/molecules/HandwriteInput'
import EbImages from '@/components/molecules/EbImages'
import UserEditMasterStatus from '@/components/organisms/UserEditMasterStatus'
import FileInput from '@/components/molecules/FileInput'

export default {
  name: 'Post',

  components: {
    PostContent,
    HtmlContent,
    HandwriteInput,
    EbImages,
    UserEditMasterStatus,
    FileInput,
  },

  data() {
    return {
      post: null,
      answerText: '',
      answerNo: null,
      answerLabels: ['A', 'B', 'C', 'D'],
      answerImageData: '',
      textInputType: 'text',
      timer: null,
      elapsedTime: 0,
      elapsedTimeCurrent: 0,
      files: [],
      uploaderOptions: null,
      userAnswers: [],
    }
  },

  computed: {
    slug() {
      return this.$route.params.slug
    },

    previewToken() {
      return this.$route.query.token
    },

    isPreparedDrill() {
      return this.$store.getters.isPreparedDrill()
    },

    isExecutingDrill() {
      return this.$store.getters.isExecutingDrill()
    },

    isExecutingAnswer() {
      return this.$store.getters.isExecutingAnswer()
    },

    userAnswer() {
      return this.$store.getters.currentUserAnswer()
    },

    userAnswerId() {
      if (this.userAnswer == null) return ''
      return this.userAnswer.userAnswerId
    },

    startTimeCurrent() {
      return utilDate.calcElapsedTime()
    },

    isExecuteTarget() {
      if (this.isExecutingDrill === false) return false
      if (!this.$store.getters.currentUserAnswer()) return false
      const currentAnswer = this.$store.getters.currentUserAnswer()
      if (currentAnswer.serviceId !== this.serviceId) return false
      return currentAnswer.postSlug === this.slug
    },

    isEnabledSendAnswer() {
      if (this.answerNo !== null) return true
      if (this.answerText !== '') return true
      if (this.answerImageData !== '') return true
      if (this.files.length > 0) return true
      return false
    },

    thumbnails() {
      if (this.files.length === 0) return []

      const res = []
      this.files.map((file) => {
        if (file && file.type.startsWith('image/')) {
          const reader = new FileReader()
          reader.onload = (e) => {
            res.push(e.target.result)
          }
          reader.readAsDataURL(file)
        } else {
          this.imageSrc = null
        }
      })
      return res
    },
  },

  watch: {
    async slug(val) {
      await this.init(val)
    },
  },

  async created() {
    this.setUploaderOptions()
    await this.init()
    this.setUserAnswers()
  },

  destroyed() {
    if (this.timer) clearInterval(this.timer)
  },

  methods: {
    async init() {
      await this.setPost(this.slug)
      if (this.isPreparedDrill || this.isExecutingDrill) {
        this.resetAnswers()
        if (this.isExecutingAnswer === false) {
          await this.startAnswer()
        }
        this.startTimer()
      }
    },

    resetAnswers() {
      this.textInputType = 'text'
      this.answerText = ''
      this.answerImageData = ''
      this.answerNo = null
    },

    async setPost(slug) {
      this.$store.dispatch('setLoading', true)
      try {
        const params = this.previewToken ? { token: this.previewToken } : null
        this.post = await Post.get(this.serviceId, this.slug, params)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.debugOutput(err)
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async setUserAnswers(s) {
      this.$store.dispatch('setLoading', true)
      try {
        const params = { order: 'desc' }
        this.userAnswers = await User.getPostAnswers(this.post.postId, params, this.userToken)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.debugOutput(err)
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async startAnswer() {
      if (this.userAnswer) {
        if (this.userAnswer.postId !== this.post.postId) {
          this.$router.push(`/posts/${this.serviceId}/start`)
          return
        }
      }
      this.$store.dispatch('setLoading', true)
      try {
        const answer = await User.updateDrillAnswerStatus(
          this.drillId,
          this.userAnswerId,
          'started',
          this.userToken
        )
        const startTime = utilDate.unixtimeFromStr(answer.startedAt)
        if (this.isPreparedDrill) {
          this.$store.dispatch('startLearning', startTime)
        }
        this.$store.dispatch('startLearningCurrent', startTime)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async sendAnswer() {
      this.$store.dispatch('startLearningCurrent', 0)
      this.$store.dispatch('setLoading', true)
      try {
        await this.forceRefreshToken()

        let base64Files = []
        if (this.files.length > 0) {
          base64Files = await Promise.all(this.files.map((file) => this.convertToBase64(file)))
        }
        const nextAnswer = this.$store.getters.nextUserAnswer()
        const hasNext = Boolean(nextAnswer)
        const answer = this.post.answerType === 'text' ? this.answerText : this.answerNo
        const params = {
          answer: answer,
          answerImage: this.answerImageData,
          isFinished: !hasNext,
          files: base64Files,
        }
        const res = await User.sendDrillAnswer(
          this.drillId,
          this.userAnswerId,
          params,
          this.userToken
        )
        if (hasNext) {
          this.$store.dispatch('setLearningCurrentAnswerId', nextAnswer.userAnswerId)
          this.$store.dispatch('setLoading', false)
          this.$router.push(`/posts/${nextAnswer.serviceId}/${nextAnswer.postSlug}`)
        } else {
          this.$router.push(`/user/drills/${this.drillId}`)
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('finishLearning')
        }
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    validateAnswerText() {
      this.answerText = this.answerText.trim()
    },

    startTimer() {
      this.timer = setInterval(() => {
        this.elapsedTime = this.$store.getters.learningElapsedTime()
        this.elapsedTimeCurrent = this.$store.getters.learningElapsedTimeCurrent()
        if (this.elapsedTime <= 0 || !this.elapsedTime) clearInterval(this.timer)
      }, 1000)
    },

    setUploaderOptions() {
      this.uploaderOptions = {
        sizes: '1200x1200,800x800,400x400,400x400xs',
        mimeTypes: 'image/png,image/gif,image/jpeg',
        extensions: ['png', 'gif', 'jpg', 'jpeg'],
        sizeLimitMB: 5,
      }
    },

    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => resolve(e.target.result)
        reader.onerror = (error) => reject(error)
        reader.readAsDataURL(file)
      })
    },

    deleteFile(index) {
      this.files.splice(index, 1)
    },
  },
}
</script>
